import React from 'react'
import { Card, CardHeader, Typography, CardContent } from '@mui/material'
import useDate from '../../../../../hooks/app/useDate'
import TextEllipsis from '../../../../text/TextEllipsis'
import TextStatusUnitOfLearning from '../../../../text/TextStatus'
import ChipStatus from '../../../Analytics/InternalLink/AnalyticsCurriculum/Current/Elements/ChipStatus'

const CardUnitOfLearning = ({ item, onClick }) => {
  const { formatDate } = useDate()
  return (
    <Card onClick={onClick}>
      <CardHeader
        title={
          <>
            <TextStatusUnitOfLearning startDate={item.startDate} endDate={item.endDate} />
            <TextEllipsis>{item.name}</TextEllipsis>
          </>
        }
        classes={{ content: 'overflow-hidden' }}
        titleTypographyProps={{
          variant: 'body1',
          color: 'secondary',
          align: 'center',
          component: 'div',
          className: 'flex gap-1 items-center justify-center'
        }}
        className='bg-primary py-2'
      />
      <CardContent className='p-0' style={{ padding: 0 }}>
        <div className='grid grid-cols-2 items-center gap-2 py-2 px-2'>
          <Typography variant='inherit' className='font-bold text-right' color='primary'>
            Elements
          </Typography>
          <Typography variant='inherit'>{item.lcs.length}</Typography>
          <Typography variant='inherit' className='font-bold text-right' color='primary'>
            Start date
          </Typography>
          <Typography variant='inherit'>{formatDate(item.startDate)}</Typography>
          <Typography variant='inherit' className='font-bold text-right' color='primary'>
            End date
          </Typography>
          <Typography variant='inherit'>{formatDate(item.endDate)}</Typography>
          {item.ulStatus && (
            <div className='col-span-2 flex items-center justify-center'>
              <ChipStatus
                status={item.ulStatus.name}
                color={item.ulStatus.color}
                bgColor={item.ulStatus.bgColor}
                border={item.ulStatus.border}
              />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  )
}

export default CardUnitOfLearning
